import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import PaymentStatusModal from '../../Components/PaymentModal/PaymentStatusModal';

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('Verifying your payment status...');
  const [paymentStatus, setPaymentStatus] = useState('processing');
  const [showRetry, setShowRetry] = useState(false);
  
  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const paymentId = searchParams.get('payment_id');
        const paymentRef = searchParams.get('payment_ref');
        const paymentReference = paymentId || paymentRef;
        
        if (!paymentReference) {
          setMessage('Missing payment reference. Please try again from the beginning.');
          setPaymentStatus('failure');
          setLoading(false);
          setShowRetry(true);
          return;
        }
        
        console.log('Payment failure verification:', { paymentId, paymentRef, paymentReference });
        
        // Flouci
        if (paymentId) {
          try {
            const verifyResponse = await axios.get(`${config.SITE_API_URL}/flouci/verify/${paymentId}`, {
          headers: { 'x-api-key': config.SITE_API_KEY },
              timeout: 8000
            });
            
            if (verifyResponse.data.success) {
              const status = verifyResponse.data.result?.status;
              
              if (status === 'FAILURE') {
                const reason = verifyResponse.data.result?.details?.reason || 'Payment was declined';
                setMessage(`Payment failed: ${reason}`);
                setPaymentStatus('failure');
              } else if (status === 'EXPIRED') {
                setMessage('Payment session has expired. Please start a new payment.');
                setPaymentStatus('failure');
              } else if (status === 'PENDING') {
                setMessage('Payment is still processing. Please wait...');
                setPaymentStatus('processing');
                // Continuer le loading, peut-être réussir plus tard
                setTimeout(() => {
                  setMessage('Payment appears to have failed. Please try again.');
                  setPaymentStatus('failure');
                  setLoading(false);
                  setShowRetry(true);
                }, 5000);
                return;
              } else {
                setMessage(`Payment status: ${status}`);
                setPaymentStatus('failure');
              }
              
            } else {
              setMessage('Unable to verify payment status.');
              setPaymentStatus('failure');
            }
            
          } catch (verifyError) {
            console.error('Flouci verification error:', verifyError.message);
            
            // Essayer le webhook
            try {
              await axios.get(`${config.SITE_API_URL}/flouci/webhook`, {
                params: { payment_id: paymentId },
                headers: { 'x-api-key': config.SITE_API_KEY },
                timeout: 5000
              });
              
              setMessage('Payment status updated. Please check your orders.');
              setPaymentStatus('failure');
            } catch (webhookError) {
              setMessage('Payment verification failed. The payment may have been declined or expired.');
              setPaymentStatus('failure');
            }
          }
          
        } 
        // Konnect
        else if (paymentRef) {
          try {
            const response = await axios.get(`${config.SITE_API_URL}/konnect/webhook`, {
              params: { payment_ref: paymentRef },
              headers: { 'x-api-key': config.SITE_API_KEY },
              timeout: 8000
            });
            
            if (response.status === 200) {
              setMessage('Payment failed. Please try again.');
              setPaymentStatus('failure');
            } else {
              setMessage(response.data.message || 'Payment verification failed.');
              setPaymentStatus('failure');
            }
          } catch (error) {
            console.error('Konnect verification error:', error);
            setMessage('Payment failed. Please try again.');
            setPaymentStatus('failure');
          }
        }
        
        setShowRetry(true);
        
      } catch (error) {
        console.error('Payment verification error:', error);
        
        if (error.response?.status === 404) {
          setMessage('Payment not found. It may have expired or been cancelled.');
        } else if (error.code === 'ERR_NETWORK') {
          setMessage('Network error. Please check your internet connection.');
        } else {
          setMessage('Payment failed. Please try again.');
        }
        
        setPaymentStatus('failure');
        setShowRetry(true);
      } finally {
        setLoading(false);
      }
    };
    
    verifyPayment();
  }, [navigate, searchParams]);
  
  const handleClose = () => {
    if (showRetry) {
      navigate('/checkout'); // Retour à la page de paiement
    } else {
      navigate('/shopping-cart'); // Retour au panier
    }
  };
  
  return (
    <PaymentStatusModal
      status={paymentStatus}
      loading={loading}
      message={message}
      onClose={handleClose}
    />
  );
};

export default PaymentFailure;